<template>
  <div id="app" >
    <common-head id="head"></common-head>
    <router-view  />
  </div>
</template>
<script>
import commonHead from "@/components/Head";
export default {
  components: {
    commonHead
  },
  created() {
    // 区分生产埋点 
    if(process.env.NODE_ENV == "production"){
      this.loadBaiduSDK('https://hm.baidu.com/hm.js?55fe8df3eb9815e25c3f27e499d30fea');
    }
  },
  methods: {
    //加百度SDK
    loadBaiduSDK(src){
      (function(){
        var hm = document.createElement("script");
        hm.src = src;
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    }
  }
};
</script>
<style lang="scss" scoped>
// .appBox {
//   position: absolute;
//   min-width: 1200px;
//   max-width: 1920px;
//   width: 100%;
//   height: 100%;
//   font-family: Noto Sans S Chinese;
//   margin: 0 auto;
//   left: 0;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   padding-top: 64px;
// }
@media screen and (max-width: 767px) {
  .appBox {
    min-width: 320px;
  }
}
</style>
